import { useEffect, useState } from "react";
import { testIds } from "../constants/testIds.constants";

export const useNewsBannerHeight = () => {
  const [newsBannerHeight, setNewsBannerHeight] = useState<number>(0);

  useEffect(() => {
    const height = document.getElementById(testIds.newsBanner)?.getBoundingClientRect()?.height;
    if (height) setNewsBannerHeight(height);
  }, []);

  return { newsBannerHeight };
};
